// extracted by mini-css-extract-plugin
export var cookiesSection = "CookieNotification-module--cookiesSection--e4af2";
export var cookiesSection__btn = "CookieNotification-module--cookiesSection__btn--5775d";
export var cookiesSection__link = "CookieNotification-module--cookiesSection__link--dee75";
export var cookiesSection__text = "CookieNotification-module--cookiesSection__text--1fd2e";
export var cookiesSection__wrapper = "CookieNotification-module--cookiesSection__wrapper--602c5";